module.exports = __webpack_public_path__ + "img/UOI1080M.43ca41f1.png";